import { axios } from '@Root/API'

export const accessibilityRecords = id => {
	return axios.put(`data-pruning-accessibility/${id}`)
}
